import { Bone, SkeletonFormCard } from '../primitives';

// Matches integration/General.js: name field card + API keys section + danger zone.
export default function GeneralSettingsSkeleton() {
    return (
        <div className="row">
            <div className="col-xl-6" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                <SkeletonFormCard fields={1} showButton={false} />
                <SkeletonFormCard fields={2} showButton={false} />
                <div style={{ border: '1px solid #FECACA', borderRadius: 13, padding: 20 }}>
                    <Bone h={14} w={120} style={{ marginBottom: 12 }} />
                    <Bone h={34} w={140} r={8} />
                </div>
            </div>
        </div>
    );
}
